<div #feedbackContainer>
    <p class="body-sm-14-semibold feedback-title">Is this a good response for the question?</p>
    <div class="feedback-options-container">
        @for (option of feedbackOptions; track $index) {
            <epd-button
                type="secondary"
                [icon]="option.icon"
                [label]="option.displayName"
                size="small"
                (onClick)="onFeedbackOptionClick(option)"
            ></epd-button>
        }
    </div>
    @if (selectedFeedbackOption) {
        <form class="feedback-reasons-container" [formGroup]="feedbackForm" (ngSubmit)="submitResponseFeedback()">
            <p class="body-sm-14-semibold">Tell us why you picked "{{ selectedFeedbackOption.displayName }}"?</p>
            @if (selectedFeedbackOption.reasons) {
                <div class="checkbox-group">
                    @for (reason of selectedFeedbackOption.reasons; track reason.displayName) {
                        <epd-checkbox
                            class="reason-checkbox"
                            [label]="reason.displayName"
                            (checkedChange)="onToggleFeedbackReason(reason.value, $event)"
                        ></epd-checkbox>
                    }
                </div>
            }
            <epd-textarea
                placeholder="Do you have additional feedback?"
                [rows]="2"
                [maxRows]="4"
                (input)="onCommentChange($event)"
            ></epd-textarea>
            <epd-button class="feedback-submit-btn" type="secondary" label="Done" size="small"></epd-button>
        </form>
    }
</div>
